{
  "lang": "EN",
  "current_language": "EN",
  "meta": {
    "title": "The first financial membership for modern migrants. - MAJORITY",
    "description": "Finally, an all-in-one app with an FDIC-insured account, international money transfers, and international calls. Become a member to get your MAJORITY Visa® Debit Card and unlock all the benefits!"
  },
  "page_labels": {
    "services": "Services",
    "majority_account": "MAJORITY account",
    "majority_account_no_ssn": "No SSN",
    "majority_account_subtitle": "FDIC-insured",
    "debit_card": "Debit card",
    "debit_card_subtitle": "Shop and earn cashback",
    "features_debit_card_no_ssn": "No SSN",
    "money_transfers": "Money transfers",
    "money_transfers_subtitle": "Competitive exchange rates",
    "mobile_top_ups": "Mobile top-ups",
    "mobile_top_ups_subtitle": "No fees, instant delivery",
    "international_calling": "International calling",
    "international_calling_subtitle": "Free to 20+ countries",
    "personal_advisor": "Personalized Advisor",
    "community": "Community",
    "help": "Help",
    "contact_us": "Contact us",
    "company": "Company",
    "about": "About",
    "press": "Press",
    "careers": "Careers",
    "advisor": "Advisor",
    "terms_and_conditions": "Terms of Service",
    "complaints": "Complaints",
    "majority_tv": "MAJORITY TV",
    "legal": "Legal",
    "legal_terms_of_use": "Terms of use",
    "legal_transfer_link": "Transfer Link Terms and Conditions for Recipients",
    "migrant_handbook": "Migrant Handbook",
    "no_snn": "No SSN? No problem",
    "locations": "Locations",
    "banking": "Banking",
    "m_pay": "MAJORITY Pay",
    "help_center": "Help center",
    "m_pay_subtitle": "Pay members instantly",
    "migrant_handbook_subtitle": "Learn to thrive in the US",
    "locations_subtitle": "Visit us",
    "help_center_subtitle": "Contact us and FAQs"


  },
  "label": {
    "suggested": "Suggested",
    "global": "Global",
    "app": "App",
    "language": "Language",
    "terms_and_conditions": "Terms and conditions",
    "privacy_policy": "Privacy policy",
    "all_rights_reserved": "All rights reserved.",
    "loading": "Loading",
    "no_country_found": "No country found",
    "name": "Name",
    "email": "Email",
    "phone": "Phone",
    "faq": "FAQ",
    "features": "Features",
    "account": "MAJORITY account",
    "calling": "International calls",
    "community": "Community",
    "help": "Help",
    "about_us": "About",
    "contact_us": "Contact us",
    "contact_info": "Contact info",
    "company": "Company",
    "press": "Press",
    "careers": "Careers",
    "done": "Done",
    "search": "Search",
    "search_country": "Search country",
    "home": "Home",
    "home_page": "Home page",
    "unlimited": "Unlimited",
    "install_majority": "Install MAJORITY App",
    "install": "Install",
    "get": "Get",
    "yes": "Yes",
    "no": "No",
    "close": "Close",
    "rate": "Rate",
    "mobile_landline": "Mobile and Landline",
    "perMinute": "/min",
    "service": "Service",
    "our_rates": "Our Rates",
    "see_offer_for": "See offer for",
    "choose_a_country": "Choose a country",
    "enter_number": "Enter number",
    "all": "All",
    "show_more": "Load more",
    "ends": "Ends",
    "location": "Location",
    "categories": "Categories",
    "all_discounts": "All discounts",
    "multiple": "Multiple",
    "see_all": "See all",
    "show_all": "Show all",
    "articles": "Articles",
    "events": "Events",
    "discounts": "Discounts",
    "clear": "Clear",
    "download": "Download App",
    "download_majority": "Download MAJORITY",
    "edit": "Edit",
    "optional": "optional"
  },
  "selector": {
      "select_community": "SELECT COUNTRY",
      "select_community_details": "Where are you from? We’ll tailor your experience to your home country.",
      "select_language": "SELECT LANGUAGE",
      "confirm_button": "Confirm"
  },
  "dropdown": {
    "placeholder": "Select an item",
    "empty_placeholder": "No items found",
    "select_community": "Community"
  },
  "footer": {
    "disclaimer": [
      "The MAJORITY app facilitates banking services through Axiom Bank, N.A. Member FDIC.",
      "The MAJORITY card is issued by Axiom Bank, N.A. Member FDIC, pursuant to a license from Visa U.S.A. Inc.",
      "Transactions may be subject to limitations under applicable law, including the Bank Secrecy Act and anti-money laundering laws. Please refer to our terms and conditions for more information.",
      "<br/><a href='https://www.dllr.state.md.us/finance/consumers/comphow.shtml' class='underline' target='_blank'>The Commissioner of Financial Regulation for the State of Maryland</a> will accept all questions or complaints from Maryland residents regarding Majority Payment Services LLC (NMLS # 1991596) at 1100 North Eutaw Street, Suite 611, Baltimore, MD 21201, phone 888-784-0136.",
      "<br/>Services may be provided by Majority Payment Services LLC (NMLS # 1991596). This licensed company may be verified through the NMLS consumer access website: <a href='https://www.nmlsconsumeraccess.org/' class='underline' target='_blank'>https://www.nmlsconsumeraccess.org/</a><br/><br/>"
    ],
    "address": "MAJORITY, 2509 N. Miami Avenue #101, Miami, Florida 33127"
  },
  "action": {
    "submit": "Submit",
    "get_started": "Get started",
    "read_more": "Read more",
    "learn_more": "Learn more",
    "view_all": "View all",
    "sign_up": "Sign up"
  },
  "reviews": {
    "title": "What people are saying"
  },
  "download_app": {
    "title": "Spend, send, speak in one easy app",
    "body": "Download MAJORITY to get all the solutions you need in one place.",
    "placeholder": "Phone number",
    "download_here": "Or download it here",
    "disclaimer": "To learn more about how we collect and use your information, see our <a class=\"{variant}\" href=\"{privacy_policy_link}\">privacy policy</a>",
    "success": {
      "title": "Awesome!",
      "body": "We just texted you a download link for MAJORITY. Click it to get the app, then follow the app instructions to become a MAJORITY member."
    }
  },
  "shared": {
    "cookie_banner": "We use cookies to improve your experience",
    "cookie_consent_message": "By accepting non-essential cookies, we can provide you with a tailored browsing experience on our site. Learn more in our <a class=\"{classes}\" href=\"{link}\">Privacy Policy</a>",
    "cookie_consent_accept": "Accept all",
    "cookie_consent_decline": "Decline non-essential",
    "no_ssn_banner": "No SSN? No problem. Learn more",
    "mtu_calculator": {
      "body": "Share credits with loved ones back home, fee-free!",
      "cta": "See rates",
      "calculator_title": "Who is getting your top-up?",
      "calculator_recommended": "Recommended offer",
      "calculator_all_offers": "All offers",
      "calculator_bonus": "Bonus",
      "calculator_valid": "Valid until",
      "calculator_show_more_button": "See more options",
      "calculator_show_less_button": "See less options",
      "calculator_error": "We do not recognize this number. Please try another.",
      "calculator_fee_for": "for"
    }

  },
  "money_transfers_new": {
    "country_dropdown": "I send money to"
  }
}
